import $ from 'jquery';

$(document).ready(function() {

    function setMarginTop() {
        if ($(window).width() <= 1200) {
            $('.intro-para-date').closest('.wp-block-column').next().css('margin-top', '0');
        } else {
            $('.intro-para-date').closest('.wp-block-column').next().css('margin-top', '3rem');
        }
    }


    function moveBlocksOnMobile() {
        let columnLayoutDivCount = 0;
        $('main > div > div.wp-block-group').children().each(function() {
            let elemClass = $(this).attr('class');
            
            if(elemClass && elemClass.indexOf('wp-container-core-columns-is-layout-') != -1) {
                columnLayoutDivCount++;
            }
        });        
        
        if(columnLayoutDivCount === 1) {
            return;
        }
        
        const pdfBlock = $('.wp-block-cg-blocks-cg-pdf-block');
        const authorList = $('.author-list');
        const targetBlock = $('.section.cardBlocks, .wp-block-cg-blocks-wrapper-people-slider-s').first();
        const mainContentLastP = $('.wp-block-group > .wp-block-columns .wp-block-cg-blocks-cg-block-spaced-article .save .spaced-article-content').not('.footer p').last();

        const clientComponent = $('.wp-block-cg-blocks-cg-block-client-component');
        const EventLocator = $('.event-column');
        const introParaBlock = $('.wp-block-cg-blocks-cg-block-intro-para-s');



        if ($(window).width() <= 1200) {

            if (clientComponent.length && introParaBlock.length) {
                clientComponent.insertBefore(introParaBlock); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.insertBefore
            }

            if (EventLocator.length && introParaBlock.length) {
                EventLocator.insertBefore(introParaBlock); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.insertBefore
            }

            if (targetBlock.length) {
                if (authorList.length) {
                    authorList.insertBefore(targetBlock); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.insertBefore
                }
                if (pdfBlock.length) {
                    pdfBlock.insertBefore(targetBlock); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.insertBefore
                }
            } else if (mainContentLastP.length) {
                if (authorList.length) {
                    authorList.insertAfter(mainContentLastP); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.insertAfter
                }
                if (pdfBlock.length) {
                    pdfBlock.insertAfter(mainContentLastP); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.insertAfter
                }
            }
        }
    }


    //setMarginTop();
    moveBlocksOnMobile();

    $(window).on('resize', function() {
        //setMarginTop();
        moveBlocksOnMobile();
    });
});
